import React from "react";
import MaskedInput from "react-text-mask";
import createNumberMask from "text-mask-addons/dist/createNumberMask";
import emailMask from "text-mask-addons/dist/emailMask";
import createAutoCorrectedDatePipe from "text-mask-addons/dist/createAutoCorrectedDatePipe";
import cn from "classnames";

const FormInputMasked = ({
  label,
  placeholder,
  required,
  type,
  hint,
  horizontal,
  value,
  onChange,
  error,
  defaultValue,
  disabled = false,
  maxLength = null,
  readOnly,
  mb0,
  name,
  className,
}) => {
  const getMask = () => {
    let mask = type;

    switch (type) {
      case "email":
        mask = emailMask;
        break;
      case "number":
        mask = createNumberMask({
          prefix: "",
          suffix: "",
          thousandsSeparatorSymbol: ".",
          decimalSymbol: ",",
          allowDecimal: true,
        });
        break;
      case "phone":
        mask = [
          /[0-9]/,
          /\d/,
          /\d/,
          /\d/,
          /\d/,
          /\d/,
          /\d/,
          /\d/,
          /\d/,
          /\d/,
          /\d/,
          /\d/,
          /\d/,
        ];
        break;
      case "date":
        mask = createAutoCorrectedDatePipe("dd/mm/yyyy");
        break;
      case "text":
        mask = (s) => Array.from(s).map(() => /(.*?)/);
        break;
      default:
        break;
    }

    return mask;
  };

  const handleOnChange = (input) => {
    if (type === "number") {
      input.target.valueNumber =
        parseFloat(input.target.value.replace(/[^\d,]/g, "")) || "";
    }

    return onChange(input);
  };

  return (
    <div className={horizontal ? "row mb-3" : mb0 ? "mb-0" : "mb-3"}>
      {label ? (
        <label
          className={
            required
              ? "form-label required"
              : horizontal
              ? "form-label col-3 col-form-label text-ellipsis"
              : "form-label"
          }
        >
          {label}
        </label>
      ) : null}

      <div className={horizontal ? "col" : null}>
        <MaskedInput
          name={name}
          readOnly={readOnly}
          mask={getMask()}
          className={cn(
            error ? "form-control is-invalid" : "form-control",
            className
          )}
          placeholder={placeholder}
          guide={false}
          value={value == null ? "" : value}
          onChange={handleOnChange}
          defaultValue={defaultValue}
          disabled={disabled}
          maxLength={maxLength}
          type="text"
        />
        {hint ? <small className="form-hint">{hint}</small> : null}
        {error ? <div className="invalid-feedback">{error}</div> : null}
      </div>
    </div>
  );
};

export default FormInputMasked;
